module.exports = __webpack_public_path__ + "img/br8.73776a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br8.jpg
// module id = 7/4g
// module chunks = 0